import { Box, Stack, Typography } from "@mui/material";
import Interaction from "../../../../types/interaction/Interaction";
import BulkUpdateModal from "./BulkUpdateModal";
import { BulkExportTrigger } from "./BulkExportTrigger";
import { useTranslation } from "react-i18next";

interface BulkActionsToolbarProps {
  customerId: string | undefined;
  interactions: Interaction[];
}

/**
 * Displays a toolbar that shows the current number of selected interactions,
 * and actions to take (currently only bulk edit and bulk update)
 * @param interactions Interaction objects to perform bulk actions on
 * @returns
 */
export default function BulkActionsToolbar({
  customerId,
  interactions,
}: Readonly<BulkActionsToolbarProps>) {
  return (
    <div>
      <Stack direction="row" spacing={1} width={"100%"}>
        {interactions.length > 0 && (
          <InteractionCount count={interactions.length} />
        )}
        <BulkExportTrigger
          customerId={customerId}
          interactions={interactions}
        />
        <BulkUpdateModal customerId={customerId} interactions={interactions} />
      </Stack>
    </div>
  );
}

/**
 * Display interaction count in a styled manner
 * @param count
 * @returns
 */
function InteractionCount({ count }: { readonly count: number }) {
  const { t } = useTranslation("common");
  return (
    <Typography display="flex" alignItems="center" gap={1}>
      <Box
        sx={{
          backgroundColor: "#1976d2",
          color: "white",
          borderRadius: "50%",
          width: 30,
          height: 30,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.75rem",
          fontWeight: "bold",
        }}
      >
        {count}
      </Box>
      {t("common:selected")}
    </Typography>
  );
}
